import React, { Component } from 'react';
import './App.css';
import Router from './Router';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {MuiPickersUtilsProvider} from 'material-ui-pickers/index';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import AlertComponent from '../containers/Alert'
import { theme } from './Theme';
import ReactGA from 'react-ga';
import 'bootstrap/dist/css/bootstrap.min.css';

class App extends Component {

  componentDidMount() {
    ReactGA.initialize('UA-129181528-1');
    ReactGA.pageview(window.location.pathname + window.location.search)
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>

            <Router />

          <AlertComponent />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js